import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgxSplideModule } from 'ngx-splide';
import { FANTASY15_HOW_IT_WORKS_SLIDES } from './fantasy15-how-it-works-slides.data';
import { sliderOptions } from '@app/domain/properties/slider.properties';

@Component({
  selector: 'bingo-how-it-works-fantasy15',
  imports: [NgxSplideModule],
  templateUrl: './how-it-works-fantasy15.component.html',
  styleUrl: './how-it-works-fantasy15.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowItWorksFantasy15Component {
  protected readonly sliderOptions = sliderOptions;
  protected readonly slides = FANTASY15_HOW_IT_WORKS_SLIDES;
}
